import { ref } from 'vue';
import { pusherClient } from '../pusherClient';

export const pusherConnectionState = ref(pusherClient.connection.state);

let wasConnected = pusherClient.connection.state === 'connected';

pusherClient.connection.bind('state_change', (states: { previous: string; current: string }) => {
    pusherConnectionState.value = states.current;
    if (states.current === 'connected' && !wasConnected) {
        // dynamic import avoids circular deps with hasError / playAudio / RecentOrdersStore
        void import('./listenStoreNotifier').then(({ storeNotifierChannels }) =>
            import('./RecentOrdersStore').then(({ refreshRecentOrderIds }) => {
                for (const storeId of Object.keys(storeNotifierChannels.value)) {
                    refreshRecentOrderIds(storeId);
                }
            })
        );
    }
    wasConnected = states.current === 'connected';
});

export const connectionWatchdogTick = () => {
    const state = pusherClient.connection.state;
    pusherConnectionState.value = state;
    if (state !== 'connected' && state !== 'connecting') {
        console.warn('watchdog: reconnecting pusher', state);
        pusherClient.connect();
    }
};

/** After sleep, socket often stays "connected" but is dead — force a new connection. */
export const forcePusherReconnect = () => {
    console.warn('watchdog: force pusher reconnect');
    try {
        pusherClient.disconnect();
    } catch {
        /* ignore */
    }
    pusherClient.connect();
};

/** Binds state_change (already done at import). Kept for boot clarity. */
export const startConnectionWatchdog = () => {
    // Interval is driven by the visible alwaysTop tray via global.autoprintKeepAliveTick
};
